import axios from 'axios';

export const getSavedExportFormats = () => {
  const getSavedExports = axios.get('/seller/customextracts').then((response) => {
    const { data } = response;
    return data;
  });
  return getSavedExports;
};

export const deleteExportFormat = (exportId) => {
  const deleteFormat = axios.delete(`/seller/customextracts/${exportId}`).then((response) => response);
  return deleteFormat;
};
